const KEY = 'camptain.branchSelection';
export interface BranchSelection {
  userId: number;
  organizationId: number;
  branchId: number;
  schoolId: number | null;
}
export function readBranchSelection(): BranchSelection | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) ?? 'null') as BranchSelection | null;
    return value &&
      [value.userId, value.organizationId, value.branchId].every(
        (id) => Number.isSafeInteger(id) && id > 0,
      ) &&
      (value.schoolId === null || (Number.isSafeInteger(value.schoolId) && value.schoolId > 0))
      ? value
      : null;
  } catch {
    return null;
  }
}
export function rememberBranchSelection(value: BranchSelection | null): void {
  try {
    if (value) sessionStorage.setItem(KEY, JSON.stringify(value));
    else sessionStorage.removeItem(KEY);
  } catch {
    /* Storage may be disabled; authorization never depends on it. */
  }
}
